export const FETCH_FIXTURES = "FETCH_FIXTURES";
export const FETCH_FIXTURES_PENDING = "FETCH_FIXTURES_PENDING";
export const FETCH_FIXTURES_REJECTED = "FETCH_FIXTURES_REJECTED";
export const FETCH_FIXTURES_FULFILLED = "FETCH_FIXTURES_FULFILLED";
